var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }